<template>
  <PageWrapper :isLoading="isLoading" :isDense="isDense">
    <template #title> لیست زمانبندی کار در منزل </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderCreateHomeworkTimeDialog">
        ایجاد تایم کار در منزل
      </BButton>
    </template>
    <BRow>
      <template v-if="masterHomeworkList && masterHomeworkList.length">
        <BCol
          cols="12"
          md="3"
          v-for="homework in masterHomeworkList"
          :key="homework.id"
          class="d-flex flex-grow-1"
        >
          <HomeworkTimeCard
            :homeworkDetails="homework"
            @refetch="getAllMasterHomeworkTimes"
          ></HomeworkTimeCard>
        </BCol>
      </template>
      <template v-else>
        <BCol cols="12">
          <p class="text-center my-2">
            شما در حال حاضر هیچ تایمی برای کار در منزل ایجاد نکرده‌اید.
          </p>
        </BCol>
      </template>
    </BRow>
    <CreateHomeworkTimeDialog
      @refetch="getAllMasterHomeworkTimes"
    ></CreateHomeworkTimeDialog>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    isDense: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getAllMasterHomeworkTimes();
  },
  data() {
    return {
      isLoading: false,
      masterHomeworkList: null,
      totalCount: null,
      getAllMasterHomeworksFilters: {
        searchCommand: null,
        masterUserId: null,
        justToday: null,
        startDate: null,
        endDate: null,
        pageNumber: 1,
        count: 10,
      },
    };
  },
  methods: {
    async getAllMasterHomeworkTimes() {
      try {
        this.getAllMasterHomeworksFilters.masterUserId =
          getUserData().user.userId;
        this.isLoading = true;
        const _this = this;
        const getAllMasterHomeworks = new GetAllMasterHomeworks(_this);
        getAllMasterHomeworks.setRequestParamDataObj(
          _this.getAllMasterHomeworksFilters
        );
        await getAllMasterHomeworks.fetch((res) => {
          _this.masterHomeworkList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderCreateHomeworkTimeDialog() {
      this.$bvModal.show("create-homework-time-dialog");
    },
  },
  components: {
    CreateHomeworkTimeDialog,
    PageWrapper,
    HomeworkTimeCard,
    BRow,
    BCol,
    BButton,
    BCardGroup,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CreateHomeworkTimeDialog from "@/views/components/Homeworks/CreateHomeworkTimeDialog.vue";
import HomeworkTimeCard from "@/views/components/Homeworks/HomeworkTimeCard.vue";
import { BRow, BCol, BButton, BCardGroup } from "bootstrap-vue";
import { GetAllMasterHomeworks } from "@/libs/Api/HomeWorks";
import { getUserData } from "@/auth/utils";
</script>
